import { render, staticRenderFns } from "./verSolicitudes.vue?vue&type=template&id=22b01204&scoped=true"
import script from "./verSolicitudes.vue?vue&type=script&lang=js"
export * from "./verSolicitudes.vue?vue&type=script&lang=js"
import style0 from "./verSolicitudes.vue?vue&type=style&index=0&id=22b01204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b01204",
  null
  
)

export default component.exports